export const blogPosts = [
  {
    id: 1,
    slug: 'react-19-new-features',
    title: 'React 19 — Everything You Need to Know About the Latest Features',
    excerpt: 'React 19 brings a host of exciting features including the new React Compiler, Actions, and form handling improvements. Let\'s break down everything that changed and how it affects your workflow.',
    tags: ['React', 'JavaScript'],
    date: 'Jan 15, 2026',
    readTime: 12,
    views: '28.4K',
    icon: '⚛️',
    gradient: 'linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%)',
    isNew: true,
  },
  {
    id: 2,
    slug: 'nodejs-streams-guide',
    title: 'Node.js Streams: A Deep Dive into High-Performance I/O',
    excerpt: 'Master Node.js streams to build highly performant and memory-efficient applications. From readable and writable streams to transform streams and pipelines.',
    tags: ['Node.js', 'Backend'],
    date: 'Jan 8, 2026',
    readTime: 18,
    views: '15.7K',
    icon: '🚀',
    gradient: 'linear-gradient(135deg, #22d3a0 0%, #0ea5e9 100%)',
    isNew: false,
  },
  {
    id: 3,
    slug: 'typescript-advanced-patterns',
    title: '20+ Advanced TypeScript Patterns Every Senior Developer Should Know',
    excerpt: 'After years of TypeScript in production, here are the most powerful type patterns that will transform how you write type-safe code — from conditional types to template literal types.',
    tags: ['TypeScript'],
    date: 'Dec 28, 2025',
    readTime: 22,
    views: '52.1K',
    icon: '🔷',
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    isNew: false,
  },
  {
    id: 4,
    slug: 'nextjs-15-app-router',
    title: 'Next.js 15 App Router — Complete Production Guide with Real Examples',
    excerpt: 'The App Router has matured significantly in Next.js 15. This guide covers server components, streaming, parallel routes, and deployment strategies.',
    tags: ['Next.js', 'React'],
    date: 'Dec 20, 2025',
    readTime: 25,
    views: '41.3K',
    icon: '▲',
    gradient: 'linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%)',
    isNew: false,
  },
  {
    id: 5,
    slug: 'docker-nodejs-production',
    title: 'Docker for Node.js — The Ultimate Production Setup with Best Practices',
    excerpt: 'Containerizing Node.js apps properly is an art. Learn multi-stage builds, security hardening, health checks, and orchestration with Docker Compose.',
    tags: ['Docker', 'DevOps'],
    date: 'Dec 12, 2025',
    readTime: 16,
    views: '19.8K',
    icon: '🐳',
    gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)',
    isNew: false,
  },
  {
    id: 6,
    slug: 'react-performance-optimization',
    title: 'React Performance Optimization — The Definitive Guide for 2026',
    excerpt: 'Stop making your React apps slow. Master memoization, virtualization, lazy loading, and the React DevTools Profiler to diagnose and fix performance issues.',
    tags: ['React', 'Performance'],
    date: 'Nov 30, 2025',
    readTime: 20,
    views: '63.5K',
    icon: '⚡',
    gradient: 'linear-gradient(135deg, #fb923c 0%, #f43f5e 100%)',
    isNew: false,
  },
];

export const courses = [
  {
    id: 1,
    slug: 'react-from-scratch',
    title: 'React from Scratch — Zero to Production',
    description: 'Learn React from fundamentals to advanced patterns. Build real-world projects with hooks, context, and modern tooling.',
    tags: ['React', 'JavaScript'],
    icon: '⚛️',
    gradient: 'linear-gradient(135deg, #6366f1 0%, #818cf8 100%)',
    lessons: 48,
    duration: '12 hrs',
    students: '3.2K',
    isFree: false,
    badge: 'Popular',
    badgeColor: '#fb923c',
  },
  {
    id: 2,
    slug: 'nodejs-api-masterclass',
    title: 'Node.js API Masterclass',
    description: 'Build production-ready REST APIs with Node.js, Express, PostgreSQL, JWT auth, and cloud deployment.',
    tags: ['Node.js', 'API'],
    icon: '🛠',
    gradient: 'linear-gradient(135deg, #22d3a0 0%, #059669 100%)',
    lessons: 36,
    duration: '9 hrs',
    students: '1.8K',
    isFree: false,
    badge: null,
  },
  {
    id: 3,
    slug: 'typescript-fundamentals',
    title: 'TypeScript for JavaScript Developers',
    description: 'Migrate to TypeScript with confidence. Covers all the type system features you need for real-world projects.',
    tags: ['TypeScript'],
    icon: '🔷',
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    lessons: 24,
    duration: '6 hrs',
    students: '4.1K',
    isFree: true,
    badge: 'Free',
    badgeColor: '#22d3a0',
  },
];

export const stats = [
  { value: '4M+', label: 'Readers' },
  { value: '6,000+', label: 'Subscribers' },
  { value: '80+', label: 'Articles' },
  { value: '8K+', label: 'YouTube' },
];

export const categories = [
  { label: 'React', icon: '⚛️', slug: 'react', count: 24 },
  { label: 'Node.js', icon: '🟢', slug: 'nodejs', count: 18 },
  { label: 'TypeScript', icon: '🔷', slug: 'typescript', count: 15 },
  { label: 'Next.js', icon: '▲', slug: 'nextjs', count: 12 },
  { label: 'Docker', icon: '🐳', slug: 'docker', count: 9 },
  { label: 'Architecture', icon: '🏗', slug: 'architecture', count: 11 },
];
